import { useStore } from 'effector-react'
import {
  $totalCountOfOffers,
  offersListMounted,
  getOffers,
  $offers,
} from './model'
import { OfferRequest } from './types'

export const useOffersList = () => {
  const offers = useStore($offers)
  const loading = useStore(getOffers.pending)
  const totalCountOfOffers = useStore($totalCountOfOffers)

  const onChangeOffersList = ({ limit, page }: OfferRequest) => {
    offersListMounted({
      limit,
      page,
    })
  }

  return {
    offers,
    totalCountOfOffers,
    loading,
    onChangeOffersList,
  }
}
